import { render, staticRenderFns } from "./ReservationBadge.vue?vue&type=template&id=4d893f53&scoped=true"
import script from "./ReservationBadge.vue?vue&type=script&lang=js"
export * from "./ReservationBadge.vue?vue&type=script&lang=js"
import style0 from "./ReservationBadge.vue?vue&type=style&index=0&id=4d893f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d893f53",
  null
  
)

export default component.exports